
  var _styles = {
  "common-prize-modal-content-wrap": {
    "width": "9.13333rem",
    "height": "7.36rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "common-prize-modal-content": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "width": "100%",
    "height": "100%",
    "position": "relative",
    "marginLeft": "0.4rem"
  },
  "common-prize-modal-header": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "100%",
    "marginBottom": "0.42667rem"
  },
  "common-prize-modal-title": {
    "color": "rgb(64,21,2)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "0.56rem",
    "marginTop": "0.72rem"
  },
  "common-prize-modal-card": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "100%",
    "height": "2.88rem"
  },
  "common-prize-modal-require": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.56rem",
    "marginTop": "-0.13333rem"
  },
  "common-prize-modal-tip": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "marginTop": "0.50667rem"
  },
  "common-prize-price-value": {
    "color": "rgb(64,21,2)",
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "700",
    "fontSize": "1.2rem"
  },
  "common-prize-price-symbol": {
    "color": "rgb(64,21,2)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.37333rem"
  }
};



  module.exports = _styles;
  